import { ReactNode } from "react";
import { cn } from "@/lib/utils";

export type PillTone =
  | "upcoming"
  | "selling"
  | "soldout"
  | "completed"
  | "prelaunch"
  | "avail"
  | "neutral"
  | "gold";

const tones: Record<PillTone, string> = {
  upcoming: "bg-brand-50 text-brand-700",
  selling: "bg-avail-soft text-avail",
  soldout: "bg-sold-soft text-sold",
  completed: "bg-surface text-ink-muted",
  prelaunch: "bg-gold-50 text-gold-600",
  avail: "bg-avail-soft text-avail",
  neutral: "bg-surface text-ink-muted",
  gold: "bg-gold-50 text-gold-600",
};

export function Pill({
  tone,
  children,
  className,
}: {
  tone: PillTone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase leading-none tracking-wide",
        tones[tone],
        className
      )}
    >
      {children}
    </span>
  );
}
